module.exports = __webpack_public_path__ + "img/emailIcon.a0df286e.svg";